import React, { useCallback, useMemo, useState } from "react";

import { CButton, CCol, CRow } from "@coreui/react";
import imageExtensions from "image-extensions";
import isUrl from "is-url";
import { Scrollbars } from "react-custom-scrollbars";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { createEditor, Editor, Transforms } from "slate";
import { withHistory } from "slate-history";
import {
  Slate,
  Editable,
  useSelected,
  useFocused,
  withReact
} from "slate-react";

import FunctionsMenu from "./FunctionsMenu";
import InsertingModal from "./InsertingModal";
import paperImg from "../../../assets/paper.png";
import paper2Img from "../../../assets/paper2.svg";
import paper3Img from "../../../assets/paper3.svg";
import URL$1 from "../../../config/api";
import axios from "../../../config/axios";
import LiterarteExample from "../../LiterarteExample";
import LiterarteTip from "../../LiterarteTip";

import "./styles.css";

const Literarte = props => {
  const [imageImporter, setImageImporter] = useState(false);
  const [itemMenuFocus, setItemMenuFocus] = useState(false);
  const [tip, setTip] = useState(false);
  const [example, setExample] = useState(false);
  const user = useSelector(state => state.user);
  const userId = user.user.id;

  const [pages, setPages] = useState([
    [
      {
        type: "paragraph",
        children: [{ text: "" }]
      }
    ]
  ]);
  const [currentPage, setCurrentPage] = useState(0);

  const toggleMark = (e, editor, format) => {
    e.preventDefault();

    const isActive = isMarkActive(editor, format);

    if (isActive) {
      Editor.removeMark(editor, format);
    } else {
      Editor.addMark(editor, format, true);
    }
  };

  const isMarkActive = (editor, format) => {
    const marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
  };

  let Leaf = ({ attributes, children, leaf }) => {
    if (leaf.bold) {
      children = <strong>{children}</strong>;
    }

    if (leaf.italic) {
      children = <em>{children}</em>;
    }

    if (leaf.underline) {
      children = <u>{children}</u>;
    }

    return <span {...attributes}>{children}</span>;
  };

  const renderLeaf = useCallback(props => <Leaf {...props} />, []);

  let Element = props => {
    const { attributes, children, element } = props;

    switch (element.type) {
      case "image":
        return <ImageElement {...props} />;
      default:
        return <div {...attributes}>{children}</div>;
    }
  };

  const renderElement = props => <Element {...props} />;

  const showImageImporterModal = () => {
    setImageImporter(true);
  };

  const hideImageImporterModal = () => {
    setImageImporter(false);
  };

  const changeText = text => {
    props.onChange(text);
    let pagesAux = [];
    pages.forEach(page => {
      pagesAux.push(page);
    });
    pagesAux[currentPage] = text;

    setPages(pagesAux);
  };

  const changePage = index => {
    props.onChange(pages[index]);
    setCurrentPage(index);
  };

  const removePage = page => {
    let pagesAux = [];
    pages.forEach(page => {
      pagesAux.push(page);
    });

    let newPage = [
      {
        type: "paragraph",
        children: [{ text: "" }]
      }
    ];

    if (pagesAux.length > 1) {
      pagesAux.splice(page, 1);
      if (currentPage > pagesAux.length - 1) {
        setCurrentPage(pagesAux.length - 1);
        props.onChange(pagesAux[pagesAux.length - 1]);
      } else if (currentPage > page) {
        setCurrentPage(currentPage - 1);
        props.onChange(pagesAux[currentPage - 1]);
      } else if (currentPage === page) {
        let newCurrentPage;
        if (currentPage === 0) {
          newCurrentPage = 0;
        } else {
          newCurrentPage = currentPage - 1;
        }
        props.onChange(pagesAux[newCurrentPage]);
      }
    } else {
      pagesAux[0] = newPage;
      props.onChange(newPage);
    }
    setPages(pagesAux);
  };

  const createPage = () => {
    let pagesAux = [];
    pages.forEach(page => {
      pagesAux.push(page);
    });

    let newPage = [
      {
        type: "paragraph",
        children: [{ text: "" }]
      }
    ];
    pagesAux.push(newPage);
    setPages(pagesAux);
    setCurrentPage(pages.length);
    props.onChange(newPage);
  };

  const saveText = () => {
    props.saveTextProduction(pages);
  };

  const withImages = editor => {
    const { insertData, isVoid } = editor;

    editor.isVoid = element =>
      element.type === "image" ? true : isVoid(element);

    editor.insertData = async data => {
      const text = data.getData("text/plain");
      const { files } = data;

      if (files && files.length > 0) {
        const imageURL = await uploadPasteImage(files[0]);
        insertImage(editor, imageURL);
      } else {
        insertData(data);
      }
    };

    return editor;
  };

  const uploadPasteImage = async file => {
    const formData = new FormData();
    formData.append("file0", file);

    try {
      const imageUploadResponse = await axios.post(
        `${URL$1.api}file/question_images/${userId}`,
        formData,
        {
          headers: {
            authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      return URL$1.img + imageUploadResponse.data.files[0].url;
    } catch (error) {
      toastr.error("Erro", "Erro ao enviar imagem");
    }
  };

  const insertImage = (editor, src) => {
    const text = { text: "" };
    const image = { type: "image", url: src, children: [text] };
    Transforms.insertNodes(editor, image);

    const lineBreak = { type: "paragraph", children: [text] };
    Transforms.insertNodes(editor, lineBreak);
  };

  const isImageUrl = url => {
    if (!url) return false;
    if (!isUrl(url)) return false;
    const ext = new URL(url).pathname.split(".").pop();
    return imageExtensions.includes(ext);
  };

  let ImageElement = ({ attributes, children, element }) => {
    const selected = useSelected();
    const focused = useFocused();
    return (
      <div {...attributes}>
        <div contentEditable={false} className="d-flex justify-content-center">
          <img
            alt=""
            src={element.url}
            className="d-block rounded"
            style={{
              maxWidth: "100%",
              maxHeight: "20em",
              boxShadow: selected && focused ? "0 0 0 3px #B4D5FF" : "none"
            }}
          />
        </div>
        {children}
      </div>
    );
  };

  const editor = useMemo(
    () => withImages(withHistory(withReact(createEditor()))),
    []
  );

  return (
    <>
      {props.edit && (
        <>
          <LiterarteTip
            show={tip}
            onClose={() => {
              setTip(false);
              return false;
            }}
            type={props.activity.type.id}
          />
          <LiterarteExample
            show={example}
            onClose={() => {
              setExample(false);
              return false;
            }}
            type={props.activity.type.id}
          />
        </>
      )}
      {props.edit ? (
        <div
          style={{
            height: "100%",
            backgroundColor: "#f6f8f9",
            width: "16rem"
          }}
          className="p-3 overflow-auto"
        >
          <CButton
            block
            color="primary"
            size="lg"
            onClick={saveText}
            disabled={props.hideSaveButton}
          >
            Salvar
          </CButton>

          <hr />
          <CRow className="overflow-auto">
            {pages.map((page, index) => (
              <CCol
                key={index}
                xs="12"
                className="mb-3 d-flex flex-column align-items-center"
              >
                <div
                  className="shadow-sm"
                  onClick={() => changePage(index)}
                  style={{
                    cursor: "pointer",
                    backgroundColor: "white",
                    width: "60%",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  {index === currentPage ? (
                    <img src={paper3Img} className="w-100" />
                  ) : (
                    <img src={paper2Img} className="w-100 literarte-paper" />
                  )}
                  <div
                    className={`badge ${
                      index === currentPage
                        ? "bg-white text-primary"
                        : "badge-secondary"
                    }`}
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 0,
                      borderRadius: 0,
                      borderBottomLeftRadius: "0.25rem"
                    }}
                  >
                    {index + 1}
                  </div>
                </div>
                <div className="mt-1 text-center text-muted">
                  {/* `Página ${index + 1} ` */}
                  <i
                    className="fa fa-trash fa-10x cursor"
                    onClick={() => removePage(index)}
                  ></i>
                </div>
              </CCol>
            ))}
            <CCol
              xs="12"
              className="mb-3 d-flex flex-column align-items-center"
            >
              <div
                className="shadow-sm"
                style={{
                  backgroundColor: "white",
                  width: "60%",
                  position: "relative",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex"
                }}
              >
                <img src={paperImg} className="w-100" style={{ opacity: 0 }} />
                <div style={{ fontSize: "1.75rem", position: "absolute" }}>
                  <i
                    className="fa fa-plus fa-10x text-secondary literarte-icon"
                    style={{ cursor: "pointer" }}
                    onClick={() => createPage()}
                  ></i>
                </div>
              </div>
            </CCol>
          </CRow>
        </div>
      ) : null}
      <div
        className={`flex-1 d-flex flex-column align-items-center literarte-main-div h-100 px-5${
          props.edit ? "" : " pt-5"
        }`}
        style={{ overflow: "auto" }}
      >
        {props.edit ? (
          <>
            <div className="w-100 mt-4 p-0 d-flex align-items-center">
              <h3 className="m-0">{props.activity?.type.name}</h3>
              <i
                className="ml-3 fa fa-lightbulb-o literarte-title-icon"
                onClick={() => setTip(true)}
              ></i>
              <i
                className="ml-3 fa fa-archive literarte-title-icon"
                onClick={() => setExample(true)}
              ></i>
            </div>
            <FunctionsMenu
              showItemMenu={itemMenuFocus}
              editorAcces={editor}
              toggleMark={toggleMark}
              showImageImporter={showImageImporterModal}
              saveText={saveText}
              value={props.value}
            />
          </>
        ) : null}
        <div className={`w-100 h-100 overflow-auto ${props.className || ""}`}>
          <div className="w-100 px-3 h-100 overflow-auto">
            <Scrollbars>
              <Slate
                editor={editor}
                value={props.value}
                onChange={newValue => changeText(newValue)}
              >
                {props.edit ? (
                  <InsertingModal
                    insertImage={insertImage}
                    editorAcces={editor}
                    show={imageImporter}
                    hideImageImporter={hideImageImporterModal}
                  />
                ) : null}
                <Editable
                  className={`h-100 ${props.editableClassName || ""}`}
                  renderElement={renderElement}
                  renderLeaf={renderLeaf}
                  readOnly={!props.edit}
                  placeholder={props.placeholder}
                  onFocus={() => {
                    setItemMenuFocus(true);
                  }}
                  style={{ fontSize: "1.25rem" }}
                  onBlur={() => setTimeout(() => setItemMenuFocus(false), 200)}
                />
              </Slate>
            </Scrollbars>
          </div>
        </div>
      </div>
      {props.edit ? (
        <div
          style={{
            height: "100%",
            backgroundColor: "#f6f8f9",
            width: "16rem"
          }}
          className="p-3 overflow-auto"
        >
          <strong>Critérios</strong>
          {props.activity?.criterions.length === 0 ? (
            <div className="mt-2 d-flex align-items-center justify-content-between text-muted">
              Nenhum critério
            </div>
          ) : (
            <>
              {props.activity?.criterions.map(criterion => (
                <div
                  key={criterion.id}
                  className="mt-2 d-flex align-items-center justify-content-between text-muted"
                >
                  <span>{criterion.name}</span>
                  <span>{criterion.value}</span>
                </div>
              ))}
            </>
          )}
        </div>
      ) : null}
    </>
  );
};

export default Literarte;
